<fa-icon
  class="{{ iconClasses }}"
  [icon]="faSpinner"
  animation="spin"
></fa-icon>
